import React, { useState, useEffect } from 'react';
import Gameboard from './Gameboard';
import { teamAbbrevInGame } from './utils';
import './Scoreboard.css';

function Scoreboard({ data, preferences }) {
  const [gameboardWidth, setGameboardWidth] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      // Get the window's inner width
      const windowWidth = window.innerWidth;
      let boardWidth;

      // If the window is lte than 768px (mobile), use the whole width
      if (windowWidth <= 768) {
        boardWidth = windowWidth * 0.90;
      }
      // Otherwise, put 2 boards side-by-side
      else {
        boardWidth = windowWidth * 0.45;
      }

      // Set the value
      setGameboardWidth(boardWidth);
    };

    // Call handleResize initially and add event listener
    handleResize();
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array to run effect only once on mount

  return (
    <div className="scoreboard">
      {!data ? "Loading..." :
        data
          .filter(item => {
            // hide all other games if favoriteTeamOnly is checked
            if (preferences.favoriteTeamOnly) {
              return teamAbbrevInGame(preferences.favoriteTeam, item);
            }

            // otherwise show all games
            return true;
          })
          .sort((a, b) => {
            // show favoriteTeam's games first
            return Number(teamAbbrevInGame(preferences.favoriteTeam, b)) -
            Number(teamAbbrevInGame(preferences.favoriteTeam, a))
          })
          .map((item, index) => (
            <Gameboard key={index} item={item} width={gameboardWidth} preferences={preferences}/>
          ))
      }
    </div>
  );
}

export default Scoreboard;